/**
 * Build query params for payment reconciliation GET/POST (server expects same filters).
 * booking_statuses: comma-separated string or array of status codes.
 */
export function buildReconciliationQueryParams({
  limit,
  created_after,
  location,
  booking_statuses,
}) {
  const params = {};
  if (limit != null && limit !== "") {
    const n = Number(limit);
    if (!Number.isNaN(n) && n > 0) params.limit = String(Math.floor(n));
  }
  if (created_after) {
    params.created_after =
      typeof created_after === "string"
        ? created_after
        : created_after.format
        ? created_after.format("YYYY-MM-DD")
        : String(created_after);
  }
  if (location) params.location = String(location).trim();
  if (booking_statuses != null && booking_statuses !== "") {
    const raw = Array.isArray(booking_statuses)
      ? booking_statuses.filter(Boolean).join(",")
      : String(booking_statuses).trim();
    if (raw) params.booking_statuses = raw;
  }
  return params;
}

export function appendQueryToUrl(baseUrl, params) {
  const entries = Object.entries(params || {}).filter(
    ([, v]) => v != null && v !== ""
  );
  if (entries.length === 0) return baseUrl;
  const qs = new URLSearchParams();
  entries.forEach(([k, v]) => qs.append(k, String(v)));
  return `${baseUrl}?${qs.toString()}`;
}

export const RECONCILIATION_ISSUE_KIND_LABELS = {
  MISSING_PROVIDER_PAYMENT_ID:
    "No provider payment id in DB (placeholder txn)",
  TRANSACTION_ID_MISMATCH: "DB transaction id ≠ gateway payment",
  STATUS_DRIFT: "Booking status out of sync with gateway",
};

export function getIssueKindLabel(issueKind) {
  if (!issueKind) return "—";
  return RECONCILIATION_ISSUE_KIND_LABELS[issueKind] || issueKind;
}

/** INR display from minor units (paise). */
export function formatInrFromMinor(amountMinor) {
  if (amountMinor == null || Number.isNaN(Number(amountMinor))) return "—";
  const rupees = Number(amountMinor) / 100;
  return `₹${rupees.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function normalizeScanPayload(body) {
  const root =
    body && typeof body === "object"
      ? body.response ?? body.data ?? body
      : {};
  const summary = root.summary || {};
  return {
    issues: Array.isArray(root.issues) ? root.issues : [],
    scanned_count: root.scanned_count ?? 0,
    summary: {
      missing_provider_payment_id: summary.missing_provider_payment_id ?? 0,
      status_drift: summary.status_drift ?? 0,
      transaction_id_mismatch: summary.transaction_id_mismatch ?? 0,
    },
    remediated_booking_ids: Array.isArray(root.remediated_booking_ids)
      ? root.remediated_booking_ids
      : [],
    remediation_errors: Array.isArray(root.remediation_errors)
      ? root.remediation_errors
      : [],
  };
}
